import React, { useState, useEffect, useRef, Fragment } from "react";
import Form from "react-validation/build/form";
import ModelPopup from "../../helpers/ModelPopup";
import DialoguePopup from "../../helpers/DialoguePopup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import BoLoader from "../../helpers/BoLoader";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import RefreshToken from "../../helpers/RefreshToken";
import * as EmailValidator from "email-validator";
import superClientServiceObj from "../../services/super-client.service";

const EditSuperClient = props => (
  <ModelPopup
    show={props.show}
    onHide={props.onHide}
    modelheading={""}
    showheader={"false"}
    backdrop="static"
    keyboard={false}
    className="smallPopup issueCardSmall "
    dialogClassName="modal-dialog modal-dialog-centered mwidth-76 "
    modelbody={
      <EditSuperClients
        show={props.show}
        onHide={props.onHide}
        editsuperclient={props.editsuperclient}
        onAddClient={props.onAddClient}
        calledfrom={props.calledfrom}
      />
    }
  />
);

const EditSuperClients = ({ show, onHide, editsuperclient, onAddClient, calledfrom }) => {
  // Validation functions
  const CompanyNameRequired = value => {
    if (!value) {
      document.getElementById("companyName").classList.add("has_error");
      return <span className="help-block">Company Name is required!</span>;
    }
    document.getElementById("companyName").classList.remove("has_error");
  };

  const EmailRequired = value => {
    if (!value) {
      document.getElementById("email").classList.add("has_error");
      return <span className="help-block">Email is required!</span>;
    }
    document.getElementById("email").classList.remove("has_error");
  };

  const EmailFormatRequired = value => {
    if (!EmailValidator.validate(value)) {
      document.getElementById("email").classList.add("has_error");
      return <span className="help-block">Please enter valid email!</span>;
    }
    document.getElementById("email").classList.remove("has_error");
  };

  const form = useRef();
  const checkBtn = useRef();
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modelhdng, setMdlHdng] = useState("");
  const [modelbdy, setMdlBdy] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");
  const [boloader, setBoLoader] = useState(false);
  const [showPhoneErr, setShowPhoneErr] = useState("d-none");
  const [showPhoneMinimumErr, setShowPhoneMinimumErr] = useState("d-none");

  // Fields
  const [ClientName, setName] = useState(editsuperclient?.name || "");
  const [Mobile, setPhoneNumber] = useState(editsuperclient?.phoneNumber || "");
  const [Email, setEmail] = useState(editsuperclient?.email || "");

  // Phone validation
  const requiredPhoneNo = value => {
    const validLength = !!value && value.length >= 3;
    setIsValidPhoneNumber(validLength);
    if (!value) {
      document.getElementById("id_phonenumber").classList.add("has_error");
      setShowPhoneErr("");
      return false;
    }
    document.getElementById("id_phonenumber").classList.remove("has_error");
    setShowPhoneErr("d-none");
    return validLength;
  };

  useEffect(() => {
    if (!Mobile || Mobile.length < 3) {
      setIsValidPhoneNumber(false);
      document.getElementById("id_phonenumber").classList.add("has_error");
      setShowPhoneMinimumErr("");
    } else {
      setIsValidPhoneNumber(true);
      document.getElementById("id_phonenumber").classList.remove("has_error");
      setShowPhoneMinimumErr("d-none");
    }
  }, [Mobile]);

  // Handlers
  const onChangename = e => setName(e.target.value);
  const onChangeEmail = e => setEmail(e.target.value);
  const onChangePhoneNumber = value => {
    requiredPhoneNo(value);
    setPhoneNumber(value);
  };

  const errorAndSuccessModl = (heading, body, errIcon) => {
    setModalShow(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(errIcon);
  };

  const saveUser = async e => {
    e.preventDefault();
    form.current.validateAll();
    const phoneValid = requiredPhoneNo(Mobile);
    if (checkBtn.current.context._errors.length === 0 && phoneValid) {
      setBoLoader(true);
      try {
        const response = await superClientServiceObj.editSuperClient(
          editsuperclient.id,
          ClientName,
          Email,
          Mobile,
          false
        );
        if (response?.data?.message === "success") {
          onAddClient();
        }
      } catch (error) {
        let msgBody = error?.response?.data?.message || "Error Occured while Registering client";
        errorAndSuccessModl("Error", msgBody, "icon-error");
        const resp = await RefreshToken(error?.response?.status);
        if (resp) saveUser(e);
      } finally {
        setBoLoader(false);
      }
    }
  };

  const suspendClient = async e => {
    e.preventDefault();
    form.current.validateAll();
    const phoneValid = requiredPhoneNo(Mobile);
    if (checkBtn.current.context._errors.length === 0 && phoneValid) {
      setBoLoader(true);
      try {
        const response = await superClientServiceObj.editSuperClient(
          editsuperclient.id,
          ClientName,
          Email,
          Mobile,
          true
        );
        if (response?.data?.message === "success") {
          onAddClient();
        }
      } catch (error) {
        let msgBody = error?.response?.data?.message || "Error Occured while Registering client";
        errorAndSuccessModl("Error", msgBody, "icon-error");
        const resp = await RefreshToken(error?.response?.status);
        if (resp) suspendClient(e);
      } finally {
        setBoLoader(false);
      }
    }
  };

  return (
    <div>
      <div className="row">
        <BoLoader loading={boloader} />
        <div className="col-md-12">
          <h2>Edit Super Client</h2>
          <div className="mt-24">
            <Form onSubmit={e => e.preventDefault()} ref={form}>
              <div className="row">
                <div className="col-md-12" id="companyName">
                  <div className="form-group">
                    <label>Name*</label>
                    <div className="form-controls">
                      <Input
                        type="text"
                        className="form-control no-icon"
                        name="Name"
                        onChange={onChangename}
                        validations={[CompanyNameRequired]}
                        value={ClientName}
                        maxLength="80"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6" id="email">
                  <div className="form-group">
                    <label>Email*</label>
                    <div className="form-controls">
                      <Input
                        type="text"
                        className="form-control no-icon"
                        name="email"
                        onChange={onChangeEmail}
                        validations={[EmailRequired, EmailFormatRequired]}
                        value={Email}
                        maxLength="50"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6" id="id_phonenumber">
                  <div className="form-group">
                    <label>Phone Number*</label>
                    <div className="form-group">
                      <PhoneInput
                        className=""
                        country="us"
                        onChange={onChangePhoneNumber}
                        value={Mobile}
                      />
                      <span className={`help-block ${showPhoneErr}`}>Phone No is required!</span>
                      {!isValidPhoneNumber && (
                        <div id="id_minimumphonelength">
                          <span className={`help-block ${showPhoneMinimumErr}`}>Minimum three number are required!</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group submit-field d-flex justify-content-center mt-40 mb-0">
                    <a
                      className="btn btn-outline mr-19"
                      data-bs-dismiss="modal"
                      onClick={onHide}
                    >
                      Cancel
                    </a>
                    {calledfrom === "superclient" && (
                      <>
                        <a className="btn btn-large mr-19" onClick={saveUser}>
                          Edit Super Client
                        </a>
                        <a className="btn btn-large" onClick={suspendClient}>
                          Suspend  Client
                        </a>
                      </>
                    )}
                    {calledfrom === "suspendclient" && (
                      <a className="btn btn-large" onClick={saveUser}>
                        Unsuspend  Client
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          </div>
        </div>
      </div>
      <DialoguePopup
        show={modalShow}
        onHide={() => setModalShow(false)}
        modelheading={modelhdng}
        modelbody={modelbdy}
        modelicon={MdlIcon}
      />
    </div>
  );
};

export default EditSuperClient;
